import React, { Component, PureComponent } from 'react';

import ComplexPartner from './complexPartner';

const steps = {
	initial: 0,
	set_api_data: 0,
	set_api_key: 1,
	set_auth_link: 1,
	set_laddition_ticket: 1,
	set_api_mask: 1,
	success: 2,
};
const Odk = props => {
	return (
		<ComplexPartner
			key_={props.key_}
			index={props.index}
			setBlurBackground={props.setBlurBackground}
			steps={steps}></ComplexPartner>
	);
};

export default Odk;
